import { Box } from '@medely/web-components';
import Chat from './Chat';
import ApplicationHeaderHelpIcon from './ApplicationHeaderHelpIcon';
import ApplicationHeaderLogout from './ApplicationHeaderLogout';
import { useIsApplicationVideoHeader } from './useIsApplicationVideoHeader';

import NavBar from '../NavBar';
import React from 'react';
import SettingsDropdown from '../SettingsDropdown/SettingsDropdown';
import useCurrentUser from 'hooks/useCurrentUser';
import { Logo } from 'components/Logo';
import { AssignmentFavoriteButton } from '@mp/components/AssignmentFavoriteButton';
import { AssignmentProps, isSaasAccount, isAgencyAccount } from '@mp';

const TopBarDesktop = ({ assignment }: { assignment?: AssignmentProps }): React.ReactElement => {
  const { isApplicant, currentUser } = useCurrentUser();
  const showNavBar = !isApplicant || isSaasAccount(currentUser) || isAgencyAccount(currentUser);
  const isApplicationVideoHeader = useIsApplicationVideoHeader();
  return (
    <Box
      display="flex"
      flexDirection="row"
      flexWrap="nowrap"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        py: 1,
        px: 2,
      }}
    >
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box sx={{ pt: 1, pr: 1 }} data-testid="header-logo">
          <Logo isSaasAccount={isSaasAccount(currentUser)} company={currentUser?.company} />
        </Box>
        {showNavBar && <NavBar />}
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        {assignment && (
          <AssignmentFavoriteButton
            assignment={assignment}
            iconSize="md"
            testId="header-favorite-button"
            isIconOnly={true}
          />
        )}
        {isApplicationVideoHeader ? (
          <>
            <ApplicationHeaderHelpIcon isMobile={false} />
            <ApplicationHeaderLogout isMobile={false} />
          </>
        ) : (
          <>
            <Chat />
            <SettingsDropdown />
          </>
        )}
      </Box>
    </Box>
  );
};

export default TopBarDesktop;
